export const getHelpMeValues = () => {
  const values = ['Help me with', 'through'];
  return values;
};
